import pegasus from '../../assets/scripts/global/01-pegasus';

document.addEventListener("alpine:init", () => {
  Alpine.data("subNavigation", () => ({
    activeSection: null,
    isDropdownOpen: false,
    isFixed: false,
    positionTop: 0,
    menuItems: [],
    sectionMap: {},
    sectionTitles: [],
    activeSectionIndex: 0,
    scrollThrottle: null,
    lastScrollTop: 0,
    isScrolling: false,
    menuHeight:0,

    init() {
      this.positionTop = { top: 0, bottom: 0, left: 0 };
      this.contactBarHeight = 0;
      const dropdownMenu = this.$root.querySelector('.dropdownMenu');
      
      if(dropdownMenu) {
        const dropdownMenuRect = pegasus.getBoundingRect(dropdownMenu);
        this.menuHeight = dropdownMenuRect.height;
      }

      document.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.isDropdownOpen = false;
        }
      });

      // Initialize menu items and section map from data attribute
      this.initializeMenuData();

      this.handleScroll = () => {
        if (this.scrollThrottle) return;
        
        this.scrollThrottle = requestAnimationFrame(() => {
          this.processScroll();
          this.scrollThrottle = null;
        });
      };

      this.processScroll = () => {
        this.fix();
        
        if (window.innerWidth < 768) {
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollDelta = Math.abs(currentScrollTop - this.lastScrollTop);
          
          // Only process if there's meaningful scroll movement (prevents micro-movements)
          if (scrollDelta < 5) return;
          
          this.lastScrollTop = currentScrollTop;
          
          // Use a more reliable method to determine if we should show the navigation
          const shouldShow = currentScrollTop > 100; // Show after 100px of scroll
          
          if (shouldShow && this.mobileTransformY !== 0) {
            this.mobileTransformY = 0;
            // Auto-close dropdown when navigation appears
            if (this.isDropdownOpen) {
              this.isDropdownOpen = false;
            }
          } else if (!shouldShow && this.mobileTransformY !== -100) {
            this.mobileTransformY = -100;
            // Auto-close dropdown when navigation hides
            if (this.isDropdownOpen) {
              this.isDropdownOpen = false;
            }
          }
        } else {
          // Desktop: always show
          if (this.mobileTransformY !== 0) {
            this.mobileTransformY = 0;
          }
        }
      };

      // Use passive scroll listener for better performance
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      
      this.$el.addEventListener('alpine:destroying', () => {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        if (this.scrollThrottle) {
          cancelAnimationFrame(this.scrollThrottle);
        }
      });
      
      
      // Initialize after a short delay to ensure DOM is ready
      this.$nextTick(() => {
        setTimeout(() => {
          const contactBar = document.querySelector('[x-data="contactBar"]');
          if (contactBar) {
            this.contactBarHeight = contactBar.offsetHeight;
          }
          
          const offsetTop = this.$el.offsetTop;
          const offsetHeight = this.$el.offsetHeight;
          const offsetLeft = this.$el.offsetLeft;
          
          let actualTop = offsetTop;
          if (offsetTop === 0) {
            const rect = this.$el.getBoundingClientRect();
            actualTop = rect.top + window.scrollY;
          }
          
          this.positionTop = {
            top: actualTop,
            bottom: actualTop + offsetHeight,
            left: offsetLeft
          };
          
          this.processScroll();
        }, 100);
      });

      this.setupIntersectionObserver();
    },

    setupIntersectionObserver() {
      const sections = document.querySelectorAll('[data-anchor-id]');
      if (!sections.length) return;

      const filteredSections = [...sections].filter(section => 
        !section.closest('.Scroll__Switcher__Results__Wrapper')
      );

      if (!filteredSections.length) return;

      const observerOptions = {
        root: null,
        rootMargin: '-25% 0px -75% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const newActiveSection = entry.target.getAttribute('data-anchor-id');
            if (newActiveSection !== this.activeSection) {
              this.updateActiveSection(newActiveSection);
            }
          }
        });
      }, observerOptions);

      filteredSections.forEach((section) => {
        observer.observe(section);
      });
    },

    initializeMenuData() {
      try {
        const menuItemsData = this.$el.getAttribute('data-menu-items');
        
        if (menuItemsData) {
          this.menuItems = JSON.parse(menuItemsData);
          
          // Create section map dynamically
          this.sectionMap = {};
          this.sectionTitles = [];
          this.menuItems.forEach((item, index) => {
            if (item.anchor_id && item.title) {
              this.sectionMap[item.anchor_id] = item.title;
              this.sectionTitles.push(item.title);
            }
          });
        }
      } catch (error) {
        this.menuItems = [];
        this.sectionMap = {};
        this.sectionTitles = [];
      }
    },

    updateActiveSection(sectionId) {
      this.activeSection = sectionId;
      
      // Find the index of the active section for the rotating effect
      const sectionIds = Object.keys(this.sectionMap);
      const newIndex = sectionIds.indexOf(sectionId);
      
      if (newIndex !== -1) {
        this.activeSectionIndex = newIndex;
      }
    },

    getActiveSectionTitle() {
      if (!this.activeSection || !this.sectionMap[this.activeSection]) return '';
      return this.sectionMap[this.activeSection];
    },

    getNavClasses() {
      const classes = [];
      classes.push(this.isFixed ? 'fixed' : 'absolute');
      classes.push(this.isDropdownOpen ? 'bg-black' : 'bg-brand-dark-grey');
      return classes.join(' ');
    },

    toggleDropdown() {
      // Only allow dropdown to open if navigation is visible (mobileTransformY is 0)
      if (this.mobileTransformY === 0) {
        this.isDropdownOpen = !this.isDropdownOpen;
      } else {
        // If navigation isn't visible, close dropdown if it's open
        if (this.isDropdownOpen) {
          this.isDropdownOpen = false;
        }
      }
    },

    smoothScroll(anchorID) {

      if(anchorID === 'top') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }

      if (!anchorID) return;

      const targetEl = document.getElementById(anchorID);
      if (!targetEl) return;

      const offset = window.innerWidth > 991 ? 110 : 310; // Strange behavior with the offset being too little on mobile and too much on desktop
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    },

    fix() {
      // Don't run if position hasn't been set yet
      if (this.positionTop.top === 0 && this.positionTop.bottom === 0) {
        return;
      }
      
      const scrollY = window.scrollY;
      const subNavTop = this.positionTop.top - this.contactBarHeight;

      console.log('ScrollY:', scrollY, 'SubNavTop:', subNavTop, 'IsFixed:', this.isFixed);

      if (this.isFixed) {
        if (scrollY < subNavTop) {
          this.isFixed = false;
        }
      } else {
        if (scrollY >= subNavTop) {
          this.isFixed = true;
        }
      }
    }
  }));
});
